<template>
  <div class="terms-container">
    <!-- 返回按钮 -->
    <button class="back-button" @click="handleBack" data-lang="t_217">

    </button>

    <!-- 协议标题 -->
    <div class="terms-header">
      <h1 data-lang="t_244"></h1>
      
    </div>

    <!-- 协议内容 -->
    <div class="terms-content">
      <section class="terms-section">
        <h2 data-lang="t_245"></h2>
        <p data-lang="t_246"></p>
        <p class="important-text" data-lang="t_247"></p>
      </section>

      <section class="terms-section">
        <h2 data-lang="t_248"></h2>
        <p data-lang="t_249"></p>
        <ul>
          <li data-lang="t_250"></li>
          <li data-lang="t_251"></li>
          <li data-lang="t_252"></li>
          <li data-lang="t_253"></li>
        </ul>
        <p data-lang="t_254"></p>
      </section>

      <section class="terms-section">
        <h2 data-lang="t_255"></h2>
        <p>1. <strong data-lang="t_256"></strong><span data-lang="t_257"></span></p>
        <p>2. <strong data-lang="t_258"></strong><span data-lang="t_259"></span></p>
        <p>3. <strong data-lang="t_260"></strong>：</p>
        <ul>
          <li><strong data-lang="t_261"></strong><span data-lang="t_262"></span></li>
          <li data-lang="t_263"></li>
          <li data-lang="t_264"></li>
        </ul>
      </section>

      <section class="terms-section">
        <h2 data-lang="t_265"></h2>
        <p data-lang="t_266"> </p>
        <p>1. <strong data-lang="t_267"></strong>：</p>
        <ul>
          <li data-lang="t_268"></li>
          <li data-lang="t_269"></li>
          <li data-lang="t_270"></li>
        </ul>
        <p>2. <strong data-lang="t_271"></strong>：</p>
        <ul>
          <li data-lang="t_272"></li>
          <li data-lang="t_273"></li>
          <li data-lang="t_274"></li>
          <li data-lang="t_275"></li>
        </ul>
      </section>

      <section class="terms-section">
        <h2 data-lang="t_276"></h2>
        <p data-lang="t_277"></p>
        <p data-lang="t_278"></p>
      </section>

      <section class="terms-section">
        <h2 data-lang="t_279"></h2>
        <p>1. <strong data-lang="t_280"></strong><span data-lang="t_281"></span></p>
        <ul>
          <li data-lang="t_282"></li>
          <li data-lang="t_283"></li>
          <li data-lang="t_284"></li>
          <li data-lang="t_285"></li>
        </ul>
        <p>2. <strong data-lang="t_286"></strong><span data-lang="t_287"></span></p>
        <p>3. <strong data-lang="t_288"></strong><span data-lang="t_289"></span></p>
        <p>4. <strong data-lang="t_290"></strong><span data-lang="t_291"></span></p>
      </section>

      <section class="terms-section">
        <h2 data-lang="t_292"></h2>
        <p data-lang="t_293"></p>
        <ul>
          <li data-lang="t_294"></li>
          <li data-lang="t_295"></li>
          <li data-lang="t_296"></li>
          <li data-lang="t_297"></li>
        </ul>
        <p data-lang="t_298"></p>
      </section>

      <section class="terms-section">
        <h2 data-lang="t_299"></h2>
        <p>1. <strong data-lang="t_300"></strong><span data-lang="t_301"></span></p>
        <p>2. <strong data-lang="t_302"></strong>：</p>
        <ul>
          <li data-lang="t_303"></li>
          <li data-lang="t_304"></li>
          <li data-lang="t_305"></li>
        </ul>
      </section>

      <section class="terms-section">
        <h2 data-lang="t_306"></h2>
        <p>1. <strong data-lang="t_307"></strong><span data-lang="t_308"></span></p>
        <p>2. <strong data-lang="t_309"></strong><span data-lang="t_310"></span></p>
      </section>

      <section class="terms-section">
        <h2 data-lang="t_311"></h2>
        <p>1. <strong data-lang="t_312"></strong><span data-lang="t_313"></span></p>
        <p>2. <strong data-lang="t_314"></strong><span data-lang="t_315"></span></p>
        <p>3. <strong data-lang="t_316"></strong><span data-lang="t_317"></span></p>
      </section>

      <section class="terms-section">
        <h2 data-lang="t_318"></h2>
        <p data-lang="t_319"></p>
        <ul>
          <li><strong data-lang="t_320"></strong>：agegfgm@gmail.com</li>
          <li><strong>Telegram</strong>：https://t.me/alphasocialcha</li>
          <li><strong>Twitter</strong>：https://x.com/alphasocialcha</li>
        </ul>
        <p data-lang="t_321"></p>
      </section>
 
      <div class="terms-footer">
        <p><strong data-lang="t_322"></strong><span data-lang="t_323"></span></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TermsOfService',
  mounted() {
  	this.setLanguage();
  },
  methods: {
	setLanguage(){
		const elements = document.querySelectorAll('[data-lang]');
		
		elements.forEach(element => {
		    const langValue = element.getAttribute('data-lang');
			
		    element.innerHTML = Lang[lg][langValue];
		});
	},
    handleBack() {
      this.$emit('data-received', {
        message: 'profile',
        timestamp: new Date().toISOString(),
        source: 'terms-of-service'
      });
    }
  }
}
</script>

<style scoped>
.terms-container {
  background-color: #000000;
  color: #e0e0e0;
  min-height: 100vh;
  padding: 20px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  line-height: 1.6;
}

.back-button {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid #333;
  color: #e0e0e0;
  padding: 10px 20px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
  margin-bottom: 30px;
  transition: all 0.3s ease;
}

.back-button:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: #666;
}

.terms-header {
  text-align: center;
  margin-bottom: 40px;
  padding-bottom: 20px;
  border-bottom: 1px solid #333;
}

.terms-header h1 {
  color: #ffffff;
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 10px;
}

.last-updated {
  color: #999;
  font-size: 0.9rem;
}

.terms-content {
  max-width: 900px;
  margin: 0 auto;
}

.terms-section {
  margin-bottom: 40px;
}

.terms-section h2 {
  color: #ffffff;
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #333;
}

.terms-section p {
  margin-bottom: 16px;
  color: #cccccc;
}

.terms-section ul {
  margin-bottom: 16px;
  padding-left: 24px;
}

.terms-section li {
  margin-bottom: 8px;
  color: #cccccc;
}

.important-text {
  background: rgba(255, 255, 255, 0.05);
  border-left: 4px solid #666;
  padding: 16px;
  border-radius: 4px;
  margin: 20px 0;
}

.terms-footer {
  margin-top: 50px;
  padding-top: 20px;
  border-top: 1px solid #333;
  text-align: center;
  color: #999;
}

/* 滚动条样式 */
.terms-content::-webkit-scrollbar {
  width: 6px;
}

.terms-content::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
}

.terms-content::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .terms-container {
    padding: 15px;
  }
  
  .terms-header h1 {
    font-size: 2rem;
  }
  
  .terms-section h2 {
    font-size: 1.3rem;
  }
}

/* 打印样式 */
@media print {
  .terms-container {
    background-color: white !important;
    color: black !important;
  }
  
  .back-button {
    display: none;
  }
  
  .terms-header h1 {
    color: black !important;
  }
  
  .terms-section h2 {
    color: black !important;
  }
  
  .terms-section p, .terms-section li {
    color: #333 !important;
  }
}
</style>
